import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesConstants } from 'src/app/constants/RoutesConstants';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-no-permission-tenant',
  templateUrl: './no-permission-tenant.component.html',
  styleUrls: ['./no-permission-tenant.component.scss']
})
export class NoPermissionTenantComponent implements OnInit {

  setAdmin: boolean;
  status = true;
  closeResult: string;
  constructor(
    public themeService: ThemeService,
    public authService: AuthServiceService,
    public router: Router
  ) { }

  ngOnInit(): void {
  }

  menuToggle() {
    this.themeService.menuToggle();
  }

  ngAfterContentInit() {
    this.themeService.getColorCookie();
  }

  ngAfterViewInit() {
    if (this.themeService.getThemeCookie()) {
      this.themeService.toggleField()
    }
  }
  closeAlert() {
    this.router.navigate([RoutesConstants.TENANT_LAYOUT, RoutesConstants.TENANT_DASHBOARD]);
  }
}